export default class MockFAQService {
  constructor() {
    this.networkDelay = 2000;
  }

  fetchFAQItems() {
    return new Promise(resolve => {
      let faqItems = [];
      setTimeout(() => {
        for (let i = 0; i < 5; ++i) {
          faqItems.push({
            id: i,
            question: `question ${i}`,
            answer: `${i}Lorem ipsum dolor sit amet consectetur adipisicing elit. Ex culpa dolor, sequi a repellat doloribus! Corporis officia voluptas, expedita reprehenderit libero tempora sapiente eius quae ab ratione sunt at ipsam.`
          });
        }
        resolve(faqItems);
      }, this.networkDelay);
    });
  }
}
